import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';
import { Orgfile } from '../model/orgfile';
import { SessionHelper } from '@src/app/helpers/sessionHelper';

const httpOptionsUploade = {
  headers: new HttpHeaders({
    //'Content-Type': 'multipart/form-data',
    //'Authorization': sessionStorage.getItem('id_token')
  })
}

@Injectable({
  providedIn: 'root'
})
export class FileuploadService {

  orgUrl:string = environment.apiUrl+'/organization/';
  pi:Orgfile;
  constructor(private http:HttpClient) { }

  addorgFile(orgfile:Orgfile){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    const databody = JSON.stringify(orgfile);
    //console.log('databody: '+databody);
    const postUrl = this.orgUrl+orgfile.organizationId+'/project/'+orgfile.projectId+'/file';
    //console.log('posturl: '+postUrl);
    
    return this.http.post<string>(postUrl,databody,httpOptions);
    
   
  }
  uploadFile(file:File,url:string):Observable<any>{
    return this.http.put(url,file,httpOptionsUploade);
    
    
  }
  getTaskFiles(organizationId:string,taskId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var urlCombo = `${this.orgUrl}`+organizationId+'/task/'+taskId+'/file/list';
    return this.http.get<Orgfile[]>(urlCombo,httpOptions);
  }
    getSignedUrl(file:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
      const body = JSON.stringify({ Key: file });
      return this.http.post<any>(environment.apiUrl+'/docstore/getsignedgeturl',body,httpOptions);


  }
  deleteFile(file:Orgfile){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+file.projectId+'/file/'+file.fileId,httpOptions);

  }

  // The backend mints the object key (scoped to the org) and returns it as `key`.
  getSignedUploadUrl(filename: string, contentType: string, organizationId: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    const body = JSON.stringify({ Key: filename, ContentType: contentType, organizationId });
    return this.http.post<any>(`${environment.apiUrl}/docstore/getsignedurl`, body, httpOptions);
  }
  

  getorgFileUrl(file:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
      const body = JSON.stringify({ Key: file });
      return this.http.post<any>(environment.apiUrl+'/docstore/getsignedgeturl',body,httpOptions);

   
  }
  getorgFileDB(orgId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var urlCombo = `${this.orgUrl}`+orgId+'/image';
    return this.http.get<any>(urlCombo,httpOptions);
  }

  deleteorgFile(){
    //TODO
  }
}
